import type { SVGProps } from 'react';
const SvgIconLogout = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path
      fill="#1A202C"
      d="M15.824 7.928 19.904 12l-4.08 4.072v-1.995a.89.89 0 0 0-.89-.89h-4.45v-2.374h4.45c.493 0 .89-.397.89-.89zM21.758 12c0-.427-.17-.834-.47-1.135L16.98 6.57a1.72 1.72 0 0 0-2.937 1.217v1.246h-3.56a1.78 1.78 0 0 0-1.78 1.78v2.374c0 .983.797 1.78 1.78 1.78h3.56v1.246a1.722 1.722 0 0 0 2.937 1.217l4.306-4.295c.3-.3.471-.708.471-1.135zM9 5.473c.493 0 .89-.397.89-.89a.89.89 0 0 0-.89-.89H6.033a3.264 3.264 0 0 0-3.264 3.263v10.088a3.264 3.264 0 0 0 3.264 3.264H9c.493 0 .89-.397.89-.89a.89.89 0 0 0-.89-.89H6.033c-.82 0-1.484-.664-1.484-1.484V6.956c0-.82.664-1.483 1.484-1.483z"
    />
  </svg>
);
export default SvgIconLogout;
